import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DrawerItem from "../../Components/DrawerItem/DrawerItem";
import classesCss from './RightDrawer.module.css'
import {useState} from 'react';

const RightDrawer = ({close, rightDrawerWidth, firstPage, secondPage}) => {
    const [currentList, setCurrentList] = useState("");

    const changeCurrentList = (clickedItemText) => {
        setCurrentList(clickedItemText);
    };

    return (
        <div style={{width: rightDrawerWidth}} className={`flex flex-col ${classesCss.drawer}`}>
            <IconButton sx={{
                marginRight: 'auto',
            }} onClick={close}>
                <CloseIcon sx={{
                    fontSize: '20px',
                }}/>
            </IconButton>
            <div className={"flex justify-center items-center w-full pa2"}>
                <input type="text" placeholder={"What can we help you find?"} className={classesCss.drawer__searchBar}/>
                <IconButton sx={{
                    marginTop: '15px'
                }}>
                    <SearchIcon/>
                </IconButton>
            </div>
            {
                firstPage.dropdowns.map(({text}, index) => <DrawerItem text={text}
                                                                       key={index}
                                                                       cb={changeCurrentList}/>)
            }
            {
                firstPage.links.map(({url, text}, index) => <DrawerItem text={text} key={index}
                                                                 url={url}
                                                                 type={"link"}/>)
            }
            <div id={"header__drawer__page"} style={{
                zIndex: '100',
                height: '100%',
                transform: 'scaleX(0)',
                transition: 'all 1s',
                backgroundColor: 'white',
                transformOrigin: 'right',
                overflowX: 'hidden',
            }} className={"flex flex-col w-full absolute"}>
                <IconButton sx={{
                    marginRight: 'auto',

                }} onClick={() => {
                    document.getElementById("header__drawer__page").style.transform = "scaleX(0)";
                    changeCurrentList("")
                }}>
                    <ArrowBackIosIcon sx={{
                        fontSize: '20px',
                        marginLeft: '5px'
                    }}/>
                </IconButton>
                {
                    secondPage.map((list) => {
                        let items = [];
                        const dropdowns = Object.entries(list).filter(([text]) => currentList===text);
                        if (typeof(dropdowns[0]) !== "undefined") {
                            items = dropdowns[0][1].map(({url, text}, index) => {
                                return (
                                    <DrawerItem text={text}
                                                key={index}
                                                url={url}
                                                type={"link"}/>
                                )
                            })
                        }
                        return items;
                    })
                }
            </div>
        </div>
    );
};

export default RightDrawer;
